import { ZidShipApiService } from './service';
import ApiClientFactory from '../../api/client-factory';

const service = new ZidShipApiService(ApiClientFactory());

export function ZidShipApiServiceFactory(): typeof service {
  return service;
}
